import { render } from "./AppleLabelGridItem.vue?vue&type=template&id=407f32bc&scoped=true"
import script from "./AppleLabelGridItem.vue?vue&type=script&lang=js"
export * from "./AppleLabelGridItem.vue?vue&type=script&lang=js"

import "./AppleLabelGridItem.vue?vue&type=style&index=0&id=407f32bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407f32bc"]])

export default __exports__